import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"
import * as Basic from "../../../Modules/BasicFields"

export default function EmotePodium( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const [ memory, setMemory ] = useState(null)

    const requiredData = [
        memory
    ]

    const cfgName = "pulse_emote_podium_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setMemory( cfg.memory || "last")
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.memory = memory

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ memory ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.SelectInput name="Memory" value={memory} setValue={setMemory} 
                                   options={[
                                        { label: "Last", value: "last" },
                                        { label: "1 minute", value: "1_min" },
                                        { label: "5 minutes", value: "5_min" },
                                   ]}
                />
            </SettingsGroup> 
        </>
    )
}
